import { Alert } from './Alert';

class AvailabilityNotification {
  constructor({ config, classes }) {
    if (!config) throw Error('Product config is reqired!');
    this.config = {
      action: 'set_product_observed',
      ...config,
    };
    this.classes = {
      wrapper: '.projector__availability_notification',
      input: '.projector__availability_notification .--input',
      button: '.projector__availability_notification .--submit',
      ...classes,
    };
    this.nodes = {
      wrapper: document.querySelector(this.classes.wrapper),
      input: document.querySelector(this.classes.input),
      button: document.querySelector(this.classes.button),
    };
    this.init();
  }

  isEmailValid() {
    return this.nodes.input.closest('.f-group').classList.contains('--success');
  }

  async sendRequest() {
    const { action, id, sizes } = this.config;
    const [size] = Object.keys(sizes);
    const email = this.nodes.input.value;
    const url = `/ajax/projector.php?action=${action}&product=${id}&size=${size}&email=${email}`;
    const res = await fetch(url);
    return (res.ok) ? res.json() : false;
  }

  hadleSubmit(e) {
    e.preventDefault();
    if (this.isEmailValid()) {
      this.sendRequest().then((res) => {
        if (res.status === 'ok') {
          Alert.show({ text: window.Literals.projector.addedAvailabilityNotification, duration: 2500 });
        } else {
          Alert.show({ text: window.Literals.projector.somethingGoesWrong, duration: 2500 });
        }
      }).catch(() => {
        Alert.show({ text: window.Literals.projector.somethingGoesWrong, duration: 2500 });
      });
    }
  }

  handleKeyPress(e) {
    const { keyCode } = e;
    if (keyCode === 13) {
      this.hadleSubmit(e);
    }
  }

  removeEvents() {
    this.nodes.input.removeEventListener('change', (e) => this.handleKeyPress(e));
    this.nodes.button.removeEventListener('click', (e) => this.hadleSubmit(e));
  }

  setEvents() {
    this.removeEvents();
    this.nodes.input.addEventListener('keypress', (e) => this.handleKeyPress(e));
    this.nodes.button.addEventListener('click', (e) => this.hadleSubmit(e));
  }

  init() {
    this.setEvents();
  }
}

export default AvailabilityNotification;
